module.exports = __webpack_public_path__ + "img/Carte-apaym-05.3a0979a1.png";